<script setup lang="ts">
// Sierra's page head: an eyebrow (12/700 info uppercase, with an optional italic
// `tagline`), the h1 (30/700, 25 on phones), a muted `sub` of at most 70 characters a
// line, and the `actions` slot on the right (primary action last). A `tabs` slot sits
// under it all.
defineProps<{ title: string; eyebrow?: string | undefined; tagline?: string | undefined; sub?: string | undefined }>();
</script>

<template>
  <header class="itc-page-head">
    <div class="itc-page-head__row">
      <div class="itc-page-head__text">
        <div v-if="eyebrow" class="itc-page-head__eyebrow">
          {{ eyebrow }}<i v-if="tagline"> · {{ tagline }}</i>
        </div>
        <h1 class="itc-page-head__title">{{ title }}</h1>
        <p v-if="sub || $slots.sub" class="itc-page-head__sub"><slot name="sub">{{ sub }}</slot></p>
      </div>
      <div v-if="$slots.actions" class="itc-page-head__actions"><slot name="actions" /></div>
    </div>
    <div v-if="$slots.tabs" class="itc-page-head__tabs"><slot name="tabs" /></div>
  </header>
</template>

<style scoped>
.itc-page-head {
  margin-bottom: 18px;
}
.itc-page-head__row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
}
.itc-page-head__text {
  min-width: 0;
}
.itc-page-head__eyebrow {
  margin-bottom: 2px;
  color: var(--itc-info);
  font-family: var(--itc-font-display);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}
.itc-page-head__eyebrow i {
  color: var(--itc-muted);
  font-style: italic;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: none;
}
.itc-page-head__title {
  margin: 0;
  font-family: var(--itc-font-display);
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1.05;
  text-wrap: balance;
}
.itc-page-head__sub {
  max-width: 70ch;
  margin: 4px 0 0;
  color: var(--itc-muted);
}
.itc-page-head__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.itc-page-head__tabs {
  margin-top: 14px;
}
@media (max-width: 720px) {
  .itc-page-head__title {
    font-size: 25px;
  }
}
</style>
